module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'active_scenario_' + _vm.currentScenario
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadedScenario === null),
      expression: "loadedScenario === null"
    }],
    staticClass: "choose_scenario"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSelectList.length > 1),
      expression: "activeSelectList.length > 1"
    }],
    staticClass: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('scenarios.scenarioTemplate')) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSelectList.length > 1),
      expression: "activeSelectList.length > 1"
    }],
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentScenario),
      expression: "currentScenario"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loadedScenario !== null
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentScenario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "empty",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.chooseScenarioTemplate')))]), _vm._v(" "), _vm._l((_vm.activeSelectList), function(scenario) {
    return _c('option', {
      domProps: {
        "value": scenario.name
      }
    }, [_vm._v("\n            " + _vm._s(scenario.label) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.currentScenario === _vm.selectList[0].name) ? _c('scenario-question-recognition', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[1].name) ? _c('scenario-question-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[2].name) ? _c('scenario-two-level-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[3].name) ? _c('scenario-notice', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[4].name) ? _c('scenario-question-interview', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[5].name) ? _c('scenario-denta-promotion', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[6].name) ? _c('scenario-akvamir', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.otherTemplate(_vm.currentScenario)) ? _c('AudioCustomizer', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id,
      "p-scenario": _vm.loadedScenario
    },
    on: {
      "set": _vm.setScenario,
      "update:pScenario": function($event) {
        _vm.loadedScenario = $event
      },
      "update:p-scenario": function($event) {
        _vm.loadedScenario = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[7].name) ? _c('Konstruktor', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id,
      "available-sms-gateways": _vm.availableSmsGateways,
      "p-scenario": _vm.loadedScenario
    },
    on: {
      "set": _vm.setScenario,
      "update:availableSmsGateways": function($event) {
        _vm.availableSmsGateways = $event
      },
      "update:available-sms-gateways": function($event) {
        _vm.availableSmsGateways = $event
      },
      "update:pScenario": function($event) {
        _vm.loadedScenario = $event
      },
      "update:p-scenario": function($event) {
        _vm.loadedScenario = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[8].name) ? _c('scenario-question-yes-no-multi-lang', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-121590ca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/Scenario.vue
// module id = 651
// module chunks = 42